// categories of the "Television Broadcasting" (id: 555c6bd38af667b6bbf11197) sector
export const categoryOptions = [
  {
    "name": "Cable and other subscription programming",
    "id": "555bc5e225a9732ca20a1050",
    "divisionId": "555c6bd38af667b6bbf11197"
  }, {
    "name": "Free-to-air television broadcasting",
    "id": "555bc5e225a9732ca20a1151",
    "divisionId": "555c6bd38af667b6bbf11197"
  }
];